module.exports = "https://static.moomoo.com/components/invite-guide/images/forbidden-nn.4abd4a3d0c.png";